import { Drawer } from "../ui/Overlay";
import { Notice } from "../ui/Notice";
import { Tag } from "../ui/Tag";
import { useT } from "../../lib/i18n";
import { fmt, type Level } from "../../lib/model";
import type { ValidateResult } from "../../lib/validate";

/** 发布校验清单：只列未通过的关，点击整卡跳转到该关 */
export function PublishCheck({
  levels, results, onClose, onJump,
}: { levels: Level[]; results: ValidateResult[]; onClose: () => void; onJump: (id: number) => void }) {
  const t = useT();
  const bad = levels.map((lv, i) => ({ lv, r: results[i] })).filter((x) => !x.r.ok);
  return (
    <Drawer
      title={t("ver.checkTitle")}
      width={720}
      onClose={onClose}
      extra={
        <Tag tone={bad.length ? "danger" : "success"}>
          {bad.length ? t("ver.checkFailTag", { n: bad.length }) : t("ver.checkPassTag", { n: levels.length })}
        </Tag>
      }
    >
      {!bad.length ? (
        <Notice tone="info">{t("ver.checkPassBody", { n: levels.length })}</Notice>
      ) : (
        <div className="flex flex-col gap-2.5">
          <Notice tone="danger">{t("ver.checkFailBody", { n: bad.length })}</Notice>
          {bad.map(({ lv, r }) => (
            <div
              key={lv.id}
              onClick={() => onJump(lv.id)}
              className="cursor-pointer rounded-base border border-line-lighter border-l-[3px] border-l-danger px-3 py-2.5"
            >
              <div className="mb-1 flex items-center gap-2.5">
                <strong>{t("ver.diff.level", { id: lv.id, name: lv.name })}</strong>
                <span className="text-xs text-ink-placeholder">{t("ver.checkStats", { c: fmt(r.C), total: fmt(r.total) })}</span>
                <span className="ml-auto text-xs text-primary">{t("ver.checkJump")}</span>
              </div>
              <ul className="m-0 list-disc pl-5 text-sm leading-7 text-danger">
                {r.reasons.map((m, i) => <li key={i}>{t(m.key, m.vars)}</li>)}
              </ul>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}
